import { JsonProperty } from "../../../models/utilities/json-property";
import { IPriceSummaryTotal } from "../../../shared/models/price-summary-totals";

export class CreditHoldOrderDetails implements IPriceSummaryTotal {
    
    public id : string = '';
    
    public description : string = '';
	
	public poNumber : string = '';
	
	public jobName : string = '';

    public subtotal : number = 0.0;
 
    public freight : number = 0.0;
 
    public tax : number = 0.0;
 
    public total : number = 0.0; 

    @JsonProperty({ toType: 'datetime' })
    public createdOn: Date | undefined = undefined;

    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;

    // UI helpers
    public isChecked : boolean = false;
    public uuid : string = '';
    
}